module.exports = __webpack_public_path__ + "static/media/logo_long.2129bc71.png";